import { DateTime } from "luxon";

/** CRM business calendar for objective dashboards. */
export const TARGET_ZONE = "Europe/Paris";

/**
 * Days to plot on the global month objective chart (right-hand bars).
 *
 * - Current month: start of month → today inclusive (to-date progression only).
 * - Past month: full calendar month.
 * - Future month: empty (no projection).
 */
export function listGlobalMonthChartDays(monthIso: string, now: DateTime = DateTime.now()): DateTime[] {
    const today = now.setZone(TARGET_ZONE).startOf("day");
    const startOfMonth = DateTime.fromISO(monthIso, { zone: TARGET_ZONE }).startOf("month");
    const endOfMonth = DateTime.fromISO(monthIso, { zone: TARGET_ZONE }).endOf("month").startOf("day");

    if (!startOfMonth.isValid || !endOfMonth.isValid) {
        return [];
    }

    // Future month: nothing to show.
    if (startOfMonth > today) {
        return [];
    }

    const chartEnd = endOfMonth <= today ? endOfMonth : today;

    const days: DateTime[] = [];
    let current = startOfMonth;
    while (current <= chartEnd) {
        days.push(current);
        current = current.plus({ days: 1 });
    }
    return days;
}
